export default __webpack_public_path__ + "static/media/discover1.09d4d98c.svg";